let audioItems = document.querySelectorAll(".right_image_left_content_with_audio .word_audio");
if (audioItems) {
    audioItems.forEach(element => {
        element.addEventListener("click", function () {
            var audio1 = element.parentElement.querySelector("audio");
            if (audio1) {
                if (audio1.paused) {
                    audio1.play();
                } else {
                    audio1.pause();
                }
            }
        })
    });
}